import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
    Fragment
} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Select from "react-select";
import _ from "lodash";
import moment from "moment";
import uuid from "uuid";

import Dropzone from "../global/form/Dropzone";
import MaterialDateTimePicker from "../global/form/MaterialDateTimePicker";
import OverLoading from "../global/OverLoading";
import { getCategories } from "../../actions/admin/category";
import { getMalls } from "../../actions/admin/mall";
import { getStores } from "../../actions/admin/store";
import { addPromo } from "../../actions/admin/promo";
import { toggleModal } from "../../actions/modal";
import { getOfferOptions } from "../../actions/admin/offer_option";

const FormCreate = forwardRef(
    ({ addPromo, getCategories, getMalls, getStores, toggleModal, getOfferOptions }, ref) => {
        const submitButtonRef = useRef();

        const selectCategoryRef = useRef();

        const selectStoreRef = useRef();

        const selectMallRef = useRef();
        const titleRef = useRef();

        useImperativeHandle(ref, () => ({
            submitForm() {
                submitButtonRef.current.click();
            }
        }));

        const [loading, setLoading] = useState(false);

        const [categoryOptions, setCategoryOptions] = useState([]);

        const [mallOptions, setMallOptions] = useState([]);

        const [storeOptions, setStoreOptions] = useState([]);

        const [selectedCategoryOptions, setSelectedCategoryOptions] = useState(
            []
        );

        const [selectedMallOption, setSelectedMallOption] = useState(null);

        const [selectedStoreOption, setSelectedStoreOption] = useState(null);
        const [arrayOfferOptions, setArrayOfferOptions] = useState([]);
        const [objectOfferOptions, setObjectOfferOptions] = useState([]);
        const [selectedOfferOption, setSelectedOfferOption] = useState(null);
        const [inputValues, setInputValues] = useState(null);

        const [formData, setFormData] = useState({
            title: "",
            description: "",
            isDeal: "true",
            isEvent: "false",
            source: "",
            isStorePromo: "true",
            isMallPromo: "false",
            images: [],
            dateFrom: new Date(moment().startOf("day")),
            dateTill: new Date(moment().startOf("day")),
            categoryIds: [],
            offerOptionId: "",
        });

        const {
            title,
            description,
            isDeal,
            isEvent,
            isStorePromo,
            isMallPromo,
            dateFrom,
            dateTill,
            offerOptionId
        } = formData;

        useEffect(() => {
            const fetchCategoriesData = async () => {
                const categories = await getCategories();
                const categoryOptions = categories.map(category => {
                    return {
                        value: category.id,
                        label: category.name
                    };
                });
                setCategoryOptions(categoryOptions);
            };

            fetchCategoriesData();
        }, [getCategories]);

        useEffect(() => {
            const fetchMallsData = async () => {
                const malls = await getMalls();
                const mallOptions = malls.map(mall => {
                    return {
                        value: mall.id,
                        label: mall.name
                    };
                });
                setMallOptions(mallOptions);
            };

            fetchMallsData();
        }, [getMalls]);

        useEffect(() => {
            const fetchStoresData = async () => {
                const stores = await getStores();
                const storeOptions = stores.map(store => {
                    return {
                        value: store.id,
                        label: store.name
                    };
                });
                setStoreOptions(storeOptions);
            };

            fetchStoresData();
        }, [getStores]);

        useEffect(() => {
            const fetchOfferOptions = async () => {
                const offerOptions = await getOfferOptions();
                setArrayOfferOptions(offerOptions);
                const convertOfferOptions = _.groupBy(offerOptions, function (
                    option
                ) {
                    return option.group;
                });
                setObjectOfferOptions(convertOfferOptions);
            };

            fetchOfferOptions();
        }, [getOfferOptions]);

        const onChange = e => {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        };

        const handleOfferOption = e => {
            setFormData({ ...formData, [e.target.name]: e.target.value });
            if (e.target.name === "offerOptionId") {
                if (e.target.value !== "") {
                    const selectedOfferOption = _.find(arrayOfferOptions, [
                        "id",
                        parseInt(e.target.value)
                    ]);
                    setSelectedOfferOption(selectedOfferOption);
                    let inputValues = [];
                    selectedOfferOption.content.forEach((item, index) => {
                        if (item.isInput === true) {
                            inputValues["titleInput" + index] = "";
                        }
                    });
                    setInputValues(inputValues);
                } else {
                    setSelectedOfferOption(null);
                }
            }
        };

        const renderOfferOptions = Object.keys(objectOfferOptions).map(key => {
            return (
                <Fragment key={uuid.v4()}>
                    <option value={key} key={uuid.v4()} disabled>
                        {key}
                    </option>
                    {objectOfferOptions[key].map(option => {
                        let content = "";
                        option.content.forEach(item => {
                            if (item.text !== "") {
                                content += item.text;
                            } else {
                                content += "___";
                            }
                        });
                        return (
                            <option value={option.id} key={uuid.v4()}>
                                {content}
                            </option>
                        );
                    })}
                </Fragment>
            );
        });

        const handleChangeCategoryOptions = selectedOptions => {
            setSelectedCategoryOptions(selectedOptions);
            setFormData({
                ...formData,
                categoryIds: _.map(selectedOptions, "value")
            });
        };

        const handleChangeMallOption = selectedOption => {
            setSelectedMallOption(selectedOption);
            setFormData({
                ...formData,
                source: selectedOption.label
            });
        };

        const handleChangeStoreOption = selectedOption => {
            setSelectedStoreOption(selectedOption);
            setFormData({
                ...formData,
                source: selectedOption.label
            });
        };

        const onSubmit = async e => {
            e.preventDefault();
            setLoading(true);
            const addPromoResponse = await addPromo({
                ...formData,
                title: titleRef.current.innerText
            });
            setLoading(false);
            if (addPromoResponse) toggleModal();
        };

        const getSelectedCategoryOptionsValue = () => {
            if (selectedCategoryOptions && selectedCategoryOptions.length)
                return selectedCategoryOptions.length;
            else return "";
        };

        const getSelectedStoreOptionValue = () => {
            if (selectedStoreOption) return selectedStoreOption.value;
            else return "";
        };

        const getSelectedMallOptionValue = () => {
            if (selectedMallOption) return selectedMallOption.value;
            else return "";
        };

        const renderInput =
            selectedOfferOption !== null ? (
                selectedOfferOption.content.map((item, index) => {
                    if (item.isHint === false) {
                        if (item.isInput === false) {
                            return (
                                <Fragment key={index}>
                                    {" " + item.text + " "}
                                </Fragment>
                            );
                        } else {
                            return (
                                <Fragment key={index}>
                                    <input
                                        type="text"
                                        value={
                                            inputValues["titleInput" + index]
                                        }
                                        name={"titleInput" + index}
                                        onChange={e => onChangeTitleInput(e)}
                                        required
                                        style={{ width: "80px" }}
                                    />
                                </Fragment>
                            );
                        }
                    }

                    return <Fragment key={index}></Fragment>;
                })
            ) : (
                    <Fragment></Fragment>
                );

        const renderTitle =
            selectedOfferOption !== null ? (
                selectedOfferOption.content.map((item, index) => {
                    if (item.isHint === false) {
                        if (item.isInput === false) {
                            return <Fragment key={index}>{item.text}</Fragment>;
                        } else {
                            return (
                                <Fragment key={index}>
                                    {inputValues["titleInput" + index]}
                                </Fragment>
                            );
                        }
                    }

                    return <Fragment key={index}></Fragment>;
                })
            ) : (
                    <Fragment>{title}</Fragment>
                );

        const onChangeTitleInput = e => {
            setInputValues({
                ...inputValues,
                [e.target.name]: e.target.value
            });
        };

        return (
            <form
                className="form position-relative"
                onSubmit={e => onSubmit(e)}
                autoComplete="off"
            >
                {loading && <OverLoading />}
                <div className="form-group">
                    <label className="col-form-label">Category *</label>
                    <Select
                        value={selectedCategoryOptions}
                        onChange={handleChangeCategoryOptions}
                        options={categoryOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        blurInputOnSelect={false}
                        ref={selectCategoryRef}
                    />
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{
                            opacity: 0,
                            width: "100%",
                            height: 0,
                            position: "absolute"
                        }}
                        value={getSelectedCategoryOptionsValue()}
                        onChange={e => {
                            e.preventDefault();
                        }}
                        onFocus={() => selectCategoryRef.current.focus()}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="col-form-label">Title *</label>
                    {/* <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={title}
                        onChange={e => onChange(e)}
                        required
                    /> */}
                    <div className="form-group mb-4">
                        <div className="input-group mb-2">
                            <div className="input-group-prepend">
                                <div className="input-group-text">Options</div>
                            </div>
                            <select
                                className="form-control"
                                name="offerOptionId"
                                value={offerOptionId}
                                onChange={e => handleOfferOption(e)}
                                required
                            >
                                <option value="">Select a option</option>
                                {renderOfferOptions}
                            </select>
                        </div>
                    </div>
                    <div className="form-group mb-4">Input: {renderInput}</div>
                    <div className="form-group mb-4">
                        Title:{" "}
                        <span className="text-primary" ref={titleRef}>
                            {renderTitle}
                        </span>
                    </div>
                </div>
                <div className="form-group">
                    <label className="col-form-label">Description</label>
                    <textarea
                        className="form-control"
                        name="description"
                        value={description}
                        onChange={e => onChange(e)}
                    >
                        {description}
                    </textarea>
                </div>
                <div className="form-group padding-bottom-15">
                    <div className="form-check form-check-inline">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isDeal"
                                value="true"
                                checked={isDeal === "true"}
                                onChange={() => {
                                    setFormData({
                                        ...formData,
                                        isDeal:
                                            isDeal === "true"
                                                ? "false"
                                                : "true",
                                        isEvent:
                                            isEvent === "true"
                                                ? "false"
                                                : "true"
                                    });
                                }}
                            />{" "}
                            Is Deal
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isEvent"
                                value="false"
                                checked={isEvent === "true"}
                                onChange={() => {
                                    setFormData({
                                        ...formData,
                                        isDeal:
                                            isDeal === "true"
                                                ? "false"
                                                : "true",
                                        isEvent:
                                            isEvent === "true"
                                                ? "false"
                                                : "true"
                                    });
                                }}
                            />{" "}
                            Is Event
                        </label>
                    </div>
                </div>
                <div className="form-group">
                    <div className="form-check form-check-inline">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isStorePromo"
                                value="true"
                                checked={isStorePromo === "true"}
                                onChange={() => {
                                    setFormData({
                                        ...formData,
                                        isStorePromo:
                                            isStorePromo === "true"
                                                ? "false"
                                                : "true",
                                        isMallPromo:
                                            isMallPromo === "true"
                                                ? "false"
                                                : "true"
                                    });
                                }}
                            />{" "}
                            Is Store Promo
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isMallPromo"
                                value="false"
                                checked={isMallPromo === "true"}
                                onChange={() => {
                                    setFormData({
                                        ...formData,
                                        isStorePromo:
                                            isStorePromo === "true"
                                                ? "false"
                                                : "true",
                                        isMallPromo:
                                            isMallPromo === "true"
                                                ? "false"
                                                : "true"
                                    });
                                }}
                            />{" "}
                            Is Mall Promo
                        </label>
                    </div>
                </div>
                {isStorePromo === "true" && isMallPromo === "false" ? (
                    <div className="form-group">
                        <label className="col-form-label">Store *</label>
                        <Select
                            value={selectedStoreOption}
                            onChange={handleChangeStoreOption}
                            options={storeOptions}
                            placeholder={"Select a store"}
                            ref={selectStoreRef}
                        />
                        <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{
                                opacity: 0,
                                width: "100%",
                                height: 0,
                                position: "absolute"
                            }}
                            value={getSelectedStoreOptionValue()}
                            onChange={e => {
                                e.preventDefault();
                            }}
                            onFocus={() => selectStoreRef.current.focus()}
                            required
                        />
                    </div>
                ) : (
                        ""
                    )}
               
                {isMallPromo === "true" && isStorePromo === "false" ? (
                    <div className="form-group">
                        <label className="col-form-label">Mall *</label>
                        <Select
                            value={selectedMallOption}
                            onChange={handleChangeMallOption}
                            options={mallOptions}
                            placeholder={"Select a mall"}
                            ref={selectMallRef}
                        />
                        <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{
                                opacity: 0,
                                width: "100%",
                                height: 0,
                                position: "absolute"
                            }}
                            value={getSelectedMallOptionValue()}
                            onChange={e => {
                                e.preventDefault();
                            }}
                            onFocus={() => selectMallRef.current.focus()}
                            required
                        />
                    </div>
                ) : (
                        ""
                    )}
               
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label className="col-form-label">
                                Date From *
                            </label>
                            <div>
                                <MaterialDateTimePicker
                                    value={dateFrom}
                                    onChange={dateFrom =>
                                        setFormData({ ...formData, dateFrom })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label className="col-form-label">
                                Date Till *
                            </label>
                            <div>
                                <MaterialDateTimePicker
                                    value={dateTill}
                                    onChange={dateTill =>
                                        setFormData({ ...formData, dateTill })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label className="col-form-label">Images *</label>
                    <Dropzone
                        multiple={true}
                        placeholder="Choose the images"
                        onDrop={images =>
                            setFormData({ ...formData, images: images })
                        }
                    />
                </div>
                <div className="form-group">
                    <input
                        type="submit"
                        className="btn btn-primary mr-1 d-none"
                        value="Save"
                        ref={submitButtonRef}
                    />
                </div>
            </form>
        );
    }
);

FormCreate.propTypes = {
    addPromo: PropTypes.func.isRequired,
    getCategories: PropTypes.func.isRequired,
    getMalls: PropTypes.func.isRequired,
    getStores: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    getOfferOptions: PropTypes.func.isRequired
};

export default connect(
    null,
    {
        addPromo,
        getCategories,
        getMalls,
        getStores,
        toggleModal,
        getOfferOptions
    },
    null,
    {
        forwardRef: true
    }
)(FormCreate);
